import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const fetchStudentPlacedByGender = createAsyncThunk('fetchStudentPlacedByGender', async (obj, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/reports/gender-wise-reg-placed?year=${obj.year}`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const studentPlacedGender = createSlice({
    name: 'genderPlaced',
    initialState: {
        loading: false,
        studentPlacedByGender: [],
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(fetchStudentPlacedByGender.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchStudentPlacedByGender.fulfilled, (state, action) => {
            state.loading = false;
            state.studentPlacedByGender = action.payload
        })
        builder.addCase(fetchStudentPlacedByGender.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default studentPlacedGender.reducer